import { useEffect } from 'react';
import dayjs from 'dayjs';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';
import { Divider, Button } from 'antd';
import { getQuota } from '../../store/action/global';
import { HomeOutlined } from '@ant-design/icons';
import { LanguageSwitcher } from '../LanguageSwitcher/index.jsx';
import { ThemeSwitcher } from '../ThemeSwitcher/index.jsx';

export const Header = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const quotaData = useSelector((state) => state.global.quota);
  const userId = useSelector((state) => state.global.userId);
  const showLogin = useSelector((state) => state.global.showLogin);

  useEffect(() => {
    if (!showLogin) {
      getQuota();
    }
  }, [showLogin]);

  const jumpPage = (url) => {
    history.push(url);
  };

  const logout = () => {
    dispatch({
      type: 'global/logout',
    });
  };

  const loginBtn = () => {
    dispatch({
      type: 'global/setShowLogin',
      payload: true,
    });
  };

  return (
    <header>
      <div className={`${styles['container']} ${styles['header-content']}`}>
        <div>
          <a href="https://www.breezedeus.com" className={styles['logo']}>
            <HomeOutlined className={styles['logoImg']} />
            <span className={styles['logo-text']}>Pix2Text</span>
            <span className={styles['beta-tag']}>beta</span>
          </a>
        </div>

        <nav>
          <ul>
            <li>
              <div onClick={() => jumpPage('/')}>{t('header.home')}</div>
            </li>
            <li>
              <a href="https://www.breezedeus.com/article/pix2text">{t('header.models')}</a>
            </li>
            <li>
              <div onClick={() => jumpPage('/pricing')}>{t('header.pricing')}</div>
            </li>
            <li>
              <div onClick={() => jumpPage('/api-keys')}>{t('header.apiKeys')}</div>
            </li>
            <li>
              <div onClick={() => jumpPage('/tools')}>{t('header.tools')}</div>
            </li>
          </ul>
        </nav>

        <div className={styles.rightSection}>
          <div className={styles.switchers}>
            <ThemeSwitcher />
            <LanguageSwitcher />
          </div>

          {userId !== null && (
            <div className={styles.login}>
              <div className={styles.userInfo}>
                <div className={styles.quota}>
                  <div className={styles.quotaTitle}>{t('header.quota')}</div>
                  <div className={styles.quotaContent}>
                    <div>
                      <div>{t('header.ultra')}:</div>
                      <div>{quotaData.ultra_quota}</div>
                      <div>{t('header.expiresOn')} {dayjs(quotaData.ultra_expiry_date).format('YYYY-MM-DD')}</div>
                    </div>
                    <div>
                      <div>{t('header.plus')}: </div>
                      <div>{quotaData.plus_quota}</div>
                      <div>{t('header.expiresOn')} {dayjs(quotaData.plus_expiry_date).format('YYYY-MM-DD')}</div>
                    </div>
                    <div>
                      <div>{t('header.pro')}: </div>
                      <div>{quotaData.pro_quota}</div>
                      <div>{t('header.expiresOn')} {dayjs(quotaData.pro_expiry_date).format('YYYY-MM-DD')}</div>
                    </div>
                  </div>
                </div>
                <Divider style={{ margin: '10px 0', borderColor: '#d9d9d9' }} />
                <div onClick={() => history.push('/pricing')} className={styles.updatePassword}>
                  <Button type="primary" ghost block>
                    {t('header.rechargePlus')}
                  </Button>
                </div>
                <div
                  onClick={() =>
                    dispatch({
                      type: 'global/setShowUpdatePassword',
                      payload: true,
                    })
                  }
                  className={styles.updatePassword}
                >
                  <Button block>{t('header.updatePassword')}</Button>
                </div>
                <div onClick={() => logout()} className={styles.logout}>
                  <Button block>{t('header.logout')}</Button>
                </div>
              </div>
              <div className={styles.user}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className={styles['user-icon']}
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              </div>
            </div>
          )}
          {userId === null && (
            <div className={styles.loginBtn} onClick={loginBtn}>
              <Button ghost>{t('header.login')}</Button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};
